import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          '& .MuiList-root': {
            textTransform: 'capitalize',
            padding: `${theme.spacing(1.5)} !important`, // 12px
            spacing: `${theme.spacing(0.5)} !important`, // 4px
            borderColor: theme.palette.divider,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 15,
          lineHeight: 26 / 15,
          textAlign: 'left',
          textTransform: 'capitalize',
          borderRadius: theme.shape.borderRadius,
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
  };
}
